import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import EmptyLIneupImage from 'images/sports/common/empty-data.png';
import clsx from 'clsx';
import BaseballMatchLineupStore from '../lineup/store';
import OutImage from 'images/sports/common/out.png';
import InImage from 'images/sports/common/in.png';
import {
  Summary,
  Container,
  Tab,
  Button,
  ContentsHeader,
  Player,
  Row,
  List,
  ListItem,
  Header,
  EmptyLineup,
  EarnedRunAverage,
  BattingSlot
} from './styled';
import Seo from '../../../../../components/seo';

const BaseballMatchSummary = () => {
  let { id } = useParams();
  const { getLineup, data } = BaseballMatchLineupStore();

  useEffect(() => {
    getLineup(id);
  }, []);

  const setSelectedTab = (tab) => {
    data.setSelectedTab(tab);
  };

  if (data.loading) {
    return null;
  } else {
    return (
      <Summary>
        <Seo title={'스포츠 야구 상세 기록'} />
        {/* 탭 */}
        <Tab>
          <Button
            onClick={() => setSelectedTab('HOME')}
            className={clsx(data.selectedTab === 'HOME' && 'active')}
          >
            {data.homeName}
          </Button>
          <Button
            onClick={() => setSelectedTab('AWAY')}
            className={clsx(data.selectedTab === 'AWAY' && 'active')}
          >
            {data.awayName}
          </Button>
        </Tab>
        {/* 탭  끝 */}

        {/* 투수 기록 */}
        <Container>
          <Header>
            <h2>투수</h2>
          </Header>

          {/* 투수 기록 */}
          {data.isEmpty.pitcher ? (
            <EmptyLineup>
              <img src={EmptyLIneupImage} alt="empty" />
              <h3>라인업이 발표되면 업데이트 됩니다 :)</h3>
            </EmptyLineup>
          ) : (
            <List>
              <ContentsHeader>
                <Player>선수명</Player>
                {/* <div className={style.result}>결과</div> */}
                <Row>이닝</Row>
                <Row>투구수</Row>
                <Row>피안타</Row>
                <Row>피홈런</Row>
                <Row>볼넷</Row>
                <Row>삼진</Row>
                <Row>실점</Row>
                <Row>자책점</Row>
                <EarnedRunAverage>오늘 평자책</EarnedRunAverage>
                <EarnedRunAverage>시즌 평자책</EarnedRunAverage>
              </ContentsHeader>
              {data.getSelectedPitcher.length > 0 &&
                data.getSelectedPitcher.map((item, idx) => {
                  return (
                    <ListItem key={idx}>
                      <Player>{item.player.displayName}</Player>
                      {/* <div className={style.result}>
                            <div className={style.save}>
                              <span>세</span>
                            </div>
                          </div> */}
                      <Row>{item.inningPitched}</Row>
                      <Row>{item.pitchCount}</Row>
                      <Row>{item.hit}</Row>
                      <Row>{item.homeRun}</Row>
                      <Row>{item.baseOnBalls}</Row>
                      <Row>{item.strikeOuts}</Row>
                      <Row>{item.run}</Row>
                      <Row>{item.earnedRun}</Row>
                      <EarnedRunAverage>
                        {item.todayEarnedRunAverage}
                      </EarnedRunAverage>
                      <EarnedRunAverage>
                        {item.earnedRunAverage}
                      </EarnedRunAverage>
                    </ListItem>
                  );
                })}
            </List>
          )}
        </Container>

        {/* 투수 기록 끝 */}

        {/* 타자 기록 */}
        <Container>
          <Header>
            <h2>타자</h2>
          </Header>

          {data.isEmpty.batter ? (
            <EmptyLineup>
              <img src={EmptyLIneupImage} alt="empty" />
              <h3>라인업이 발표되면 업데이트 됩니다 :)</h3>
            </EmptyLineup>
          ) : (
            <List>
              <ContentsHeader>
                <BattingSlot>타순</BattingSlot>
                <Player>선수명</Player>
                <Row>타수</Row>
                <Row>득점</Row>
                <Row>안타</Row>
                <Row>타점</Row>
                <Row>홈런</Row>
                <Row>볼넷</Row>
                <Row>삼진</Row>
                <Row>사구</Row>
                <EarnedRunAverage>오늘 타율</EarnedRunAverage>
                <EarnedRunAverage>시즌 타율</EarnedRunAverage>
              </ContentsHeader>
              {data.getSelectedBatter.length > 0 &&
                data.getSelectedBatter.map((item, idx) => {
                  const { battingSlot, slotIndex } = item;
                  const dataLength = data.getSelectedBatter.length;
                  const nextIdx = idx + 1;
                  let activeIcon = false;
                  let lastIn = false;

                  if (
                    dataLength > nextIdx &&
                    battingSlot === data.getSelectedBatter[idx + 1].battingSlot
                  ) {
                    activeIcon = true;
                  }

                  if (
                    idx > 0 &&
                    dataLength > nextIdx &&
                    battingSlot === data.getSelectedBatter[idx - 1].battingSlot
                  ) {
                    activeIcon = true;

                    if (slotIndex < data.getSelectedBatter[idx - 1].slotIndex) {
                      lastIn = true;
                    }
                  }
                  return (
                    <ListItem key={idx}>
                      <BattingSlot>
                        {battingSlot}
                        {activeIcon && (
                          <img src={lastIn ? OutImage : InImage} alt="out" />
                        )}
                      </BattingSlot>
                      <Player>{item.player.displayName}</Player>
                      <Row>{item.atBat}</Row>
                      <Row>{item.run}</Row>
                      <Row>{item.hit}</Row>
                      <Row>{item.runBattedIn}</Row>
                      <Row>{item.homeRun}</Row>
                      <Row>{item.baseOnBalls}</Row>
                      <Row>{item.strikeOuts}</Row>
                      <Row>{item.hitByPitchedBall}</Row>
                      <EarnedRunAverage>
                        {item.todayBattingAverage}
                      </EarnedRunAverage>
                      <EarnedRunAverage>
                        {item.seasonBattingAverage}
                      </EarnedRunAverage>
                    </ListItem>
                  );
                })}
            </List>
          )}
        </Container>
        {/* 타자 기록 끝 */}
      </Summary>
    );
  }
};

export default BaseballMatchSummary;
